<ng-container *ngIf="isMobileView$ | async as isMobileView">
  <sky-pagination-size class="lg:mr-6" [control]="sizeControl" [smallSized]="!isMobileView"></sky-pagination-size>
</ng-container>
<div class="flex items-center mobile:mt-6" *ngIf="pages$ | async as pages">
  <button
    *ngIf="pages.length > 1"
    (click)="previousPage(pages)"
    class="w-max mr-4"
    [ngClass]="{ 'text-sky-grey-light pointer-events-none': isFirstPageSelected(pages) }"
  >
    <sky-svg-icon size="w-3" icon="chevron-left"></sky-svg-icon>
  </button>

  <ng-container *ngIf="this.pagination.totalPages > 6 && !this.isFirstThreePage">
    <a class="px-1" [class.cursor-pointer]="!this.isFirstThreePage" (click)="selectPage(0)">
      <span class="page"> 1 </span>
    </a>
    <span>...</span>
  </ng-container>

  <ng-container *ngFor="let page of pages; let index = index">
    <a class="px-1" [class.cursor-pointer]="!page.selected" (click)="selectPage(page.value)">
      <span class="page" [class.selected]="page.selected">
        {{ page.value + 1 }}
      </span>
    </a>
  </ng-container>

  <ng-container *ngIf="this.pagination.totalPages > 6 && !this.isLastThreePage">
    <span>...</span>
    <a class="px-1" [class.cursor-pointer]="!this.isLastThreePage" (click)="selectPage(this.pagination.totalPages - 1)">
      <span class="page"> {{ this.pagination.totalPages }} </span>
    </a>
  </ng-container>

  <button
    *ngIf="pages.length > 1"
    (click)="nextPage(pages)"
    class="ml-4"
    [ngClass]="{ 'text-sky-grey-light pointer-events-none': isLastPageSelected(pages) }"
  >
    <sky-svg-icon size="w-3" icon="chevron-right"></sky-svg-icon>
  </button>
</div>

<ng-container *ngIf="pages$ | async as pages"> </ng-container>
